import React, { useState } from "react";
import { GuaranteeViewData } from "./GuaranteeDataModel";

type Props = { details: GuaranteeViewData,report:boolean; };

const GuaranteePanelReportSummary: React.FC<Props> = ({ details, report=false }) => {
  return (
    <div className={`ReportSummary ${report?'increase-font':''}`}>
      {report?<h2>Report summary</h2>:<h4>Report summary</h4>}
      {/* <div>
        <span>Screning token</span>
        <span className="BlueText">89798798798378952347</span>
      </div> */}
      <div>
        <span>Status</span>
        <span
          className={`ColoredBox ${
            details.verificationStatus === "Accepted" ? "Green" : "Amber"
          }`}
        >
          {details.verificationStatus}
        </span>
      </div>
      {details.pepScreeningResult && (
        <div>
          <span>PEP Screening</span>
          <span
            className={`${
              details.pepScreeningResult === "No"
                ? "ColoredBox Green"
                : details.pepScreeningResult === "Yes"
                ? "ColoredBox Amber"
                : ""
            }`}
          >
            {details.pepScreeningResult}
          </span>
        </div>
      )}
      {details.sanctionsScreeningResult && (
        <div>
          <span>Sanctions Screening</span>
          <span
            className={`${
              details.sanctionsScreeningResult === "No"
                ? "ColoredBox Green"
                : details.sanctionsScreeningResult === "Yes"
                ? "ColoredBox Amber"
                : ""
            }`}
          >
            {details.sanctionsScreeningResult}
          </span>
        </div>
      )}
      {details.ofacScreeningResult && (
        <div>
          <span>OFAC Screening</span>
          <span
            className={`${
              details.ofacScreeningResult === "No"
                ? "ColoredBox Green"
                : details.ofacScreeningResult === "Yes"
                ? "ColoredBox Amber"
                : ""
            }`}
          >
            {details.ofacScreeningResult}
          </span>
        </div>
      )}
      <div>
        <span>Verification Method</span>
        {details.identityVerificationMethod && (
          <span
            className={`ColoredBox ${
              details.identityVerificationMethod === "Automatic"
                ? "Green"
                : "Amber"
            }`}
          >
            {details.identityVerificationMethod}
          </span>
        )}
      </div>
      <div>
        <span>Face match</span>
        <span
          className={`ColoredBox ${
            details.faceMatchPct && details.faceMatchPct > 90
              ? "Green"
              : "Amber"
          }`}
        >
          {details.faceMatchPct && `${details.faceMatchPct}%`}
        </span>
      </div>
    </div>
  );
};

export default GuaranteePanelReportSummary;

export const PopoutImage = (props: { url: string; className?: string }) => {
  const [fullSize, setFullSize] = useState(false);
  const toggleFullSize = () => setFullSize(current => !current);
  return (
    <>
      {fullSize ? (
        <div className="ImagePopout">
          <img
            className={`${props.className} PoppedOutImage`}
            src={props.url}
            alt="document"
            onClick={toggleFullSize}
          />
        </div>
      ) : (
        <img
          className={`${props.className}`}
          src={props.url}
          alt="document"
          onClick={toggleFullSize}
        />
      )}
    </>
  );
};
